<script setup>
import { trans } from '@tools/translation';
</script>

<template>
  <div class="team-list__header legacy-table__header">
    <div>{{ trans('user.organization.team.name') }}</div>
    <div>{{ trans('user.organization.team.created_at') }}</div>
    <div>{{ trans('user.organization.team.last_login') }}</div>
    <div id="actions-column" />
  </div>
</template>
